module.exports = __webpack_public_path__ + "static/media/kuro-ost-artwork.98a7c69d.jpg";